<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <h4 class="kt-panel-title">
                        {{ $t('label.wallet_settlement_blacklist.forbidden_keywords_title') }}
                    </h4>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="clearfix mb-4">
                    <button 
                        class="btn btn-primary float-right"
                        @click="openAddModal"
                    >
                        <i class="fa fa-plus"></i>
                        {{ $t('label.wallet_settlement_blacklist.forbidden_keywords_add_keyword') }}
                    </button>
                </div>
                
                <forbidden-keyword-filter :action="filterAction"></forbidden-keyword-filter>
                <kt-datatable v-if="categoryId" v-bind="datatableProps" ref="datatable"></kt-datatable>
            </kt-panel-body>
        </kt-panel>

        <div class="modal fade" id="keywordModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ isEditMode ? $t('label.wallet_settlement_blacklist.edit_keyword') : $t('label.wallet_settlement_blacklist.forbidden_keywords_add_keyword') }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal">
                            <span>&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="saveKeyword" id="keywordForm">
                        <div class="modal-body">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label for="keyword">
                                        {{ $t('label.wallet_settlement_blacklist.forbidden_keywords_keyword') }} *
                                    </kt-form-label>
                                    <kt-form-control
                                        ref="name"
                                        name="name"
                                        id="name"
                                        v-model="formData.name"
                                        :placeholder="$t('label.wallet_settlement_blacklist.forbidden_keywords_placeholder')"
                                        required
                                    />
                                </kt-form-group>
                            </kt-form-section>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{ $t('btn.cancel') }}
                            </button>
                            <button type="submit" class="btn btn-primary" id="saveKeywordBtn">
                                {{ $t('btn.save') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main-content>
</template>

<script>
import columns from '../datatable/ForbiddenKeywordColumns'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import actionsColumn from './forbidden-keyword-actions-column.vue'
import forbiddenKeywordFilter from './forbidden-keyword-filter.vue'
import mainContent from '@/components/main-content'
import toastr from 'toastr'
import $ from 'jquery'
import axios from 'axios'

export default {
    components: {
        'forbidden-keyword-filter': forbiddenKeywordFilter,
        'main-content': mainContent,
    },
    data() {
        return {
            query: {},
            isEditMode: false,
            categoryId: null,
            formData: {
                id: null,
                name: '',
            }
        }
    },
    computed: {
        isStarshop() {
            return this.$route && this.$route.params && this.$route.params.slug === 'starshop'
        },

        apiPath() {
            return (path) => {
                return this.isStarshop ? ApiUrl.starshopPath(path) : ApiUrl.path(path)
            }
        },

        currentCategorySlug() {
            return 'wallet-settlement-name-blacklist'
        },

        cleanHeaders() {
            const headers = {};

            if (AuthorizationHeader && typeof AuthorizationHeader === 'object') {
                Object.keys(AuthorizationHeader).forEach(key => {
                    const value = AuthorizationHeader[key];
                    if (value && typeof value === 'string' && value !== '[object Object]') {
                        headers[key] = value;
                    }
                });
            }

            return headers;
        },

        datatableProps() {
            return {
                id: "forbidden_keywords_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.apiPath(`admin/tags/category/${this.currentCategorySlug}`),
                            method: 'GET',
                            headers: this.cleanHeaders,
                            map: function (res) {
                                return res.data.data
                            },
                            params: this.query,
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        async fetchCategory() {
            try {
                const response = await axios({
                    url: this.apiPath(`admin/categories/${this.currentCategorySlug}`),
                    method: 'GET',
                    headers: this.cleanHeaders,
                    params: {
                        slug: this.currentCategorySlug
                    }
                })
                
                if (response.data && response.data.data && response.data.data.id) {
                    this.categoryId = response.data.data.id

                    if (this.$refs.datatable && this.$refs.datatable.KTDatatable) {
                        this.$refs.datatable.reload()
                    }
                }
            } catch (error) {
                console.error('Failed to fetch category:', error)
            }
        },
        
        filterAction(e, query) {
            this.query = { ...query };
            if (this.$refs.datatable && this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        },
        openAddModal() {
            this.isEditMode = false
            this.resetForm()
            $('#keywordModal').modal('show')
        },
        openEditModal(keyword) {
            this.isEditMode = true
            this.formData = {
                id: keyword.id,
                name: keyword.name,
            }
            $('#keywordModal').modal('show')
        },
        resetForm() {
            this.formData = {
                id: null,
                name: '',
            }
        },
        saveKeyword() {
            const form = $('#keywordForm')
            const btn = $('#saveKeywordBtn')
            
            form.validate({
                rules: {
                    name: {
                        required: true,
                        minlength: 2
                    }
                }
            })

            if (!form.valid()) {
                return
            }

            btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> ' + this.$t('btn.save'))

            const formData = {
                ...this.formData,
                categories: this.categoryId ? [this.categoryId] : []
            }

            const url = this.isEditMode 
                ? this.apiPath(`admin/tags/${this.formData.id}`)
                : this.apiPath('admin/tags')

            const method = this.isEditMode ? 'PUT' : 'POST'

            axios({
                url: url,
                method: method,
                data: formData,
                headers: this.cleanHeaders
            }).then(response => {
                this.toastr.success(response.data.message)
                $('#keywordModal').modal('hide')
                if (this.$refs.datatable && this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }).catch(({response}) => {
                if (response && response.data && response.data.errors) {
                    form.validate().showErrors(response.data.errors)
                }
                this.toastr.error(response && response.data && response.data.message ? response.data.message : this.$t('forbidden_keywords.error_message'))
            }).finally(() => {
                btn.prop('disabled', false).html(this.$t('btn.save'))
            })
        },

        deleteKeyword(id) {
            const result = confirm(this.$t('label.wallet_settlement_blacklist.confirm_delete'))
            if (!result) return

            axios({
                url: this.apiPath(`admin/tags/${id}`),
                method: 'DELETE',
                headers: this.cleanHeaders
            }).then(response => {
                this.toastr.success(response.data.message)
                if (this.$refs.datatable && this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }).catch(({response}) => {
                this.toastr.error(response && response.data && response.data.message ? response.data.message : this.$t('forbidden_keywords.delete_error'))
            })
        }
    },

    watch: {
        '$route.params.slug': {
            handler: async function (newSlug, oldSlug) {
                await this.fetchCategory()
                if (this.$refs.datatable && this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            },
            immediate: true
        }
    },

    async mounted() {
        await this.fetchCategory()

        window.editForbiddenKeyword = (keyword) => {
            this.openEditModal(keyword)
        }
        
        window.deleteForbiddenKeyword = (id) => {
            this.deleteKeyword(id)
        }
    }
}
</script>

<style scoped>
.modal-header .close {
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    font-size: 1.5rem;
}
</style>